import React from 'react';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Reply from '@mui/icons-material/Reply';
import { useI18n } from '../../../../lib/hook/useI18n';
import ThemableButton, {
  ThemableButtonProps,
} from '../../../../theme/components/Button/ThemableButton';

type ButtonProps = Pick<
  ThemableButtonProps,
  'disabled' | 'fullWidth' | 'onClick'
>;

export interface ShareRoomButtonProps extends ButtonProps {
  disableBreakPoint?: boolean;
}

const ShareRoomButton: React.FC<ShareRoomButtonProps> = (
  props: ShareRoomButtonProps
) => {
  const theme = useTheme();
  const { t } = useI18n();
  const { disableBreakPoint, ...butttonProps } = props;

  const mediaQuery = useMediaQuery(theme.breakpoints.down('md'));
  const mdDown = !disableBreakPoint && mediaQuery;

  return (
    <ThemableButton
      size="small"
      startIcon={
        <Reply
          fontSize={mdDown ? 'medium' : 'small'}
          sx={{ transform: 'scaleX(-1)' }}
        />
      }
      sx={(theme) => ({ height: theme.spacing(4), textTransform: 'none' })}
      variant="contained"
      dataTestId="button-share"
      {...butttonProps}
    >
      {t('shareRoom.button')}
    </ThemableButton>
  );
};

export default ShareRoomButton;
